const crypto= require('crypto');
const format= require("date-fns/format");

/**
 * Builds and returns a Buffer that represents the Cipher Key
 * @param key {Array} Array of ascii characters
 * @return {Buffer} Buffer
 */
function convertToBuffer(key) {
    let buf = new Buffer(32);
    key.forEach( function(e,i) {
        buf[i] = e;
    });
    return buf;
}

class Legacy {
    /**
     * @param config {Object} in the format { initVector: String, asciiKey: Array }
     */
    constructor(config) {
        this.config = {
            initVector: config.initVector,
            key: convertToBuffer(config.asciiKey)
        };
    }

    createAuthenticationToken(username) {
        if (!username) {
            throw new Error('Username required to create legacy authentication token');
        }
        // Date Example: '12/08/2015 11:00:47 PM'
        const date = format(new Date(), 'MM/dd/yyyy hh:mm:ss aa');
        const text = `username=${username}&tstamp=${date}`;
        let cipher = crypto.createCipheriv('aes-256-cbc', this.config.key, this.config.initVector);
        let encrypted = cipher.update(text, 'utf8', 'base64');
        encrypted += cipher.final('base64');
        return encrypted;
    }
}

export default Legacy;

